import { render } from "./gzhRecommendList.vue?vue&type=template&id=ff9eba3a"
import script from "./gzhRecommendList.vue?vue&type=script&lang=js"
export * from "./gzhRecommendList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__